/**
 *  Filter array by an element's input value
 *  @param {HTMLElement} element
 *  @param {array} allPlaces
 *  @returns {array} sorted by those that start with the element's input value
 */
export function autocomplete({ element, allPlaces }) {
  const filteredTags = []
  const filtered = allPlaces.filter(place => {
    if(place.data) {
      filteredTags.push(place);
    }
    let filterHotel = place.value.toLowerCase().includes(element.value.substring(0, element.value.trim().length).toLowerCase()) ||
                        place.city.toLowerCase().includes(element.value.substring(0, element.value.trim().length).toLowerCase()) ||
                        place.state_name.toLowerCase().includes(element.value.substring(0, element.value.trim().length).toLowerCase()) ||
                        place.country.toLowerCase().includes(element.value.substring(0, element.value.trim().length).toLowerCase());
          if(place.special_character) {
            filterHotel =  filterHotel || place.code.toLowerCase().includes(element.value.substring(0, element.value.trim().length).toLowerCase());
          }
    return filterHotel;
  });
  const combinedFilters =[];
  const startsWith = [];
  const notStartsWith = [];
  const tagged = [];
  let tagMapper = {};
  let setMapper = {}
  let uniqueFiltered = filtered.reduce((unique, item) => {
    if(item && item.value && !setMapper[item.value]) {
        if(item.data && item.data.location) {
          unique.push(item);
        }
    } else {
      unique.push(item);
      setMapper[item.value] = true;
    }
    return unique;
  }, [])
  uniqueFiltered.map(place => {
    if (
      place.value.substring(0, element.value.trim().length).toLowerCase() ===
      element.value.substring(0, element.value.trim().length).toLowerCase()
    ) {
      startsWith.push(place);
    } else {
      notStartsWith.push(place);
    }
  });
  filteredTags.map(place => {
      const tags = [...place.tags];
       tags.filter(eachTag => {
        if(eachTag.name
        .toLowerCase()
        .includes(element.value.substring(0, element.value.trim().length).toLowerCase())) {
      //check for uniqueness before push
          if(!tagMapper[eachTag.name]) {
            tagMapper[eachTag.name] = true;
            eachTag.data = true;
            tagged.push(eachTag);
          }
        }
      })
  })
  combinedFilters.push(startsWith.concat(notStartsWith));
  combinedFilters.push(tagged);
  return combinedFilters;
}
